import React from 'react';

const LogoutIcon = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23 4H7C6.46957 4 5.96086 4.21071 5.58579 4.58579C5.21071 4.96086 5 5.46957 5 6V30C5 30.5304 5.21071 31.0391 5.58579 31.4142C5.96086 31.7893 6.46957 32 7 32H23C23.5304 32 24.0391 31.7893 24.4142 31.4142C24.7893 31.0391 25 30.5304 25 30V24H15.63C15.3648 24 15.1104 23.8946 14.9229 23.7071C14.7354 23.5196 14.63 23.2652 14.63 23C14.63 22.7348 14.7354 22.4804 14.9229 22.2929C15.1104 22.1054 15.3648 22 15.63 22H25V6C25 5.46957 24.7893 4.96086 24.4142 4.58579C24.0391 4.21071 23.5304 4 23 4Z"
      fill="#FB9318"
    />
    <path
      d="M28.16 17.2795C27.9687 17.1157 27.7226 17.0301 27.4709 17.0398C27.2193 17.0495 26.9805 17.1539 26.8024 17.332C26.6243 17.5101 26.52 17.7488 26.5103 18.0005C26.5006 18.2521 26.5862 18.4982 26.75 18.6895L30.13 21.9995H25V23.9995H30.13L26.75 27.4595C26.6453 27.5492 26.5603 27.6595 26.5003 27.7835C26.4403 27.9076 26.4065 28.0427 26.4012 28.1805C26.3959 28.3182 26.4191 28.4555 26.4694 28.5838C26.5196 28.7122 26.5959 28.8287 26.6933 28.9262C26.7908 29.0236 26.9074 29.0999 27.0357 29.1502C27.164 29.2004 27.3013 29.2236 27.4391 29.2183C27.5768 29.213 27.7119 29.1793 27.836 29.1192C27.96 29.0592 28.0704 28.9742 28.16 28.8695L34 23.0695L28.16 17.2795Z"
      fill="#FB9318"
    />
  </svg>
);

export default LogoutIcon;
